import contract from '@mailobj-browser/front/js/contracts/contract.js'
import menu from './menu/menu.js'

export default contract({
  menu
})
